import { render, staticRenderFns } from "./HealthCheckForm.vue?vue&type=template&id=63cbbec1"
import script from "./HealthCheckForm.vue?vue&type=script&lang=ts"
export * from "./HealthCheckForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports